import * as types from './mutation-types'
import Vue from 'vue'
import { IPositionRemarquableState } from './state'
import { MutationTree } from 'vuex/types'
import { AloPositionRemarquable, IAloPositionRemarquableConstParam } from '@/models/alo/AloPositionRemarquable';
import glider from '@/api/glider';
import {i18n} from '@/locale/vueI18n'

/*
  Need to use export default({}) rather than export default {}
  ref links: https://github.com/TypeStrong/ts-loader/issues/588
*/
const mutations:MutationTree<IPositionRemarquableState> = {
     
    //Gestion des recherches de missions
    [types.POSITIONREMARQUABLE_REQUEST]: state => {
        state.status = i18n.t('Admin.Loading',{item:i18n.t('Admin.PositionRemarquable.Title').toString()}).toString()
        state.positionRemarquableLoading = true
    },
    [types.POSITIONREMARQUABLE_SUCCESS]: (state, positionRemarquables:Array<AloPositionRemarquable>) => {
        state.status = i18n.t('Admin.LoadingOk',{item:i18n.t('Admin.PositionRemarquable.Title').toString()}).toString()
        state.positionRemarquables = positionRemarquables          
        state.positionRemarquableLoading = false      
    },
    [types.POSITIONREMARQUABLE_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.PositionRemarquable.Title').toString()}).toString()
        state.positionRemarquables = []
        state.positionRemarquableLoading = false
    },
    [types.POSITIONREMARQUABLE_SELECT_DETAIL_REQUEST]: (state, itemId:number) => {
        state.status = i18n.t('Admin.Loading',{item:`${i18n.t('Admin.PositionRemarquable.Title').toString()} ${itemId}`}).toString()
        state.positionRemarquableLoading = true
    },
    [types.POSITIONREMARQUABLE_SELECT_DETAIL_ERROR]: state => {
        state.status = i18n.t('Admin.LoadingError',{item:i18n.t('Admin.PositionRemarquable.Title').toString()}).toString()
        state.positionRemarquableLoading = false
    },
    [types.POSITIONREMARQUABLE_SELECT_DETAIL_SUCCESS]: (state,positionRemarquable:AloPositionRemarquable) => {
        state.status = i18n.t('Admin.LoadingOk',{item:`${i18n.t('Admin.PositionRemarquable.Title').toString()} ${positionRemarquable.prmId}`}).toString()        
        //1, on met à jour de m'positionRemarquable dans la liste des positionRemarquables
        const index = state.positionRemarquables.findIndex(m => m.prmId == positionRemarquable.prmId)
        state.positionRemarquables.splice(index == -1 ? state.positionRemarquables.length : index, index == -1 ? 0 : 1, positionRemarquable)
        state.positionRemarquableLoading = false
    },
    [types.POSITIONREMARQUABLE_SELECT_DETAIL]: (state,positionRemarquable:AloPositionRemarquable) => {                
        state.originalAdmPositionRemarquable = positionRemarquable
        state.modifiedAdmPositionRemarquable = new AloPositionRemarquable({...positionRemarquable} as IAloPositionRemarquableConstParam)
    },
    [types.POSITIONREMARQUABLE_SAVE_REQUEST]: (state,libelle:string) => {
        state.status = i18n.t('Admin.SaveItem',{item:`${i18n.t('Admin.PositionRemarquable.Title').toString()} ${libelle}`}).toString()
        state.positionRemarquableLoading = true
    },
    [types.POSITIONREMARQUABLE_SAVE_ERROR]: state => {
        state.status = i18n.t('Admin.ErrorSave',{item:i18n.t('Admin.PositionRemarquable.Title').toString()}).toString()
        state.positionRemarquableLoading = false
    },
    [types.POSITIONREMARQUABLE_UPDATE_MODIFIED_ADM]: (state, newProperties:Object) => {        
        state.modifiedAdmPositionRemarquable = {...state.modifiedAdmPositionRemarquable,...newProperties}
    },
    [types.POSITIONREMARQUABLE_UPDATE_FILTER_ADM]: (state, newProperties:Object) => {        
        state.adminFilter = {...state.adminFilter,...newProperties}
    } 
}


export default mutations
